export default "__VITE_ASSET__a94afb21__"